var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1370",
    "data-name": "Rectangle 1370",
    width: 16,
    height: 16,
    transform: "translate(247 993)",
    fill: "#9b9c9d",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_294",
    "data-name": "Mask Group 294",
    transform: "translate(-247 -993)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_-_2022-01-24T135620.097",
    "data-name": "svgexport-6 - 2022-01-24T135620.097",
    transform: "translate(247 993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7765",
    "data-name": "Path 7765",
    d: "M8,.4C3.589.4,0,3.63,0,7.6a6.656,6.656,0,0,0,1.271,3.894,6.217,6.217,0,0,1-1.193,3.65.267.267,0,0,0,.189.455l.037,0a14.246,14.246,0,0,0,4.431-1.424A8.68,8.68,0,0,0,8,14.8c4.411,0,8-3.23,8-7.2S12.411.4,8,.4ZM4.267,8.667A1.067,1.067,0,1,1,5.333,7.6,1.068,1.068,0,0,1,4.267,8.667ZM8,8.667A1.067,1.067,0,1,1,9.067,7.6,1.068,1.068,0,0,1,8,8.667Zm3.733,0A1.067,1.067,0,1,1,12.8,7.6,1.068,1.068,0,0,1,11.733,8.667Z",
    fill: "#9b9c9d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.33f02a0e5c185a5401d4fe9e72d67d09.svg";
export { ForwardRef as ReactComponent };